import { render } from "./TheBreadcrumbItem.pug?vue&type=template&id=25de29a6&lang=pug"
import script from "./TheBreadcrumbItem.js?vue&type=script&lang=js"
export * from "./TheBreadcrumbItem.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__